import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/directory",
    name: "Team Member Directory",
    component: () => import("./teamDirectory.vue"),
  },
  {
    path: "/company-alert",
    name: "Company Alerts",
    component: () => import("./companyAlert.vue"),
  },
  {
    path: "/:resourceTypeSlug(resources)/:categorySlug?",
    name: "Resources",
    component: () => import("./assetResources.vue"),
    props: true,
  },
] satisfies RouteRecordRaw[];
